// src/mocks/browser.js
import { setupWorker } from "msw";
import { mockTripHandlers } from "../services/api/trips/mockTripApi";
import { mockAuthHandlers } from "@/services/api/auth/mockAuthApi.ts";

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(...mockTripHandlers, ...mockAuthHandlers);
